import React, {useState} from 'react';

import * as S from './TopDestinationsUI.styles';
import useArrayToggler, {
  ArrayTogglerBehaviorTypes,
} from '../../../../../shared/hooks/useArrayToggler';
import RightArrowNewIconHome from '../../../../Icons/ArrowRightNew';
import LeftArrowNewIcon from '../../../../Icons/ArrowLeftNew';

import {defaultTheme} from '@stencil/build-theme';
import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';
import HappyAngleLeftIcon from '@stencil/icons/src/HappyAngleLeftIcon/HappyAngleLeftIcon';

import useCarousel from '../../../../../shared/hooks/useCarousel';

const TopDestinationsUI = ({data, eventMiddlewareForFE, sliderClicksGAHandler}) => {
  const [tagId, setTagId] = useState(0);

  const [isChecked, onClickHandler] = useArrayToggler(
    data,
    item => item.id,
    ArrayTogglerBehaviorTypes.radio,
    items => {
      let index = 0;
      data.find((tagsListItem, tagsListItemIndex) => {
        if (tagsListItem.id === items[0].id) {
          index = tagsListItemIndex;
          return true;
        }
      });
      setTagId(index);
    },
  );

  const {
    dataList,
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(data[tagId].cityList, 4);

  const hasAnySelectedActiveState = data.find(item => isChecked(item));

  return (
    <S.SuggestedMainWrapper>
      <S.SuggestedHeaderNavOuter>
        {data.map((item, index) => (
          <li
            key={'TopDestinationTab' + index}
            className={
              isChecked(item) || (!hasAnySelectedActiveState && index === 0) ? 'active' : ''
            }
            onClick={() => onClickHandler(item)}
          >
            {item.name}
          </li>
        ))}
      </S.SuggestedHeaderNavOuter>

      <S.SuggestedCardList>
        {dataList &&
          dataList.map((item, index) => (
            <S.SuggestCardListLi
              key={'TopDestinationItem' + index}
              hasContent={item?.asp && item.nh}
            >
              <a href={item.seo_url || ''} title={item.h_text || ''}>
                <S.SuggestCardImage src={item.img_processed.landscape.jpg.g} alt={item.sub_text} />
                <S.SuggestedMainText>{item.h_text}</S.SuggestedMainText>
                {(item?.asp &&
                  item?.nh(
                    <S.SuggestedPriceWrap>
                      <S.SuggestedPaxText>{item.nh} options starting at</S.SuggestedPaxText>
                    </S.SuggestedPriceWrap>,
                  )) ||
                  null}
                {(item?.asp && (
                  <S.SuggestedPriceWrap>
                    <S.RuppeIconSuggest />
                    <S.SuggestedPriceText>{item.asp}</S.SuggestedPriceText>
                    <S.SuggestedPaxText>per room/night</S.SuggestedPaxText>
                  </S.SuggestedPriceWrap>
                )) ||
                  null}
              </a>
            </S.SuggestCardListLi>
          ))}
      </S.SuggestedCardList>
      {isLeftCursorActive && (
        <S.SliderArrowLeft
          onClick={eventMiddlewareForFE({
            onClick: () => {
              decrement();
              // sliderClicksGAHandler(`-${leftCursor}`);
            },
          })}
        >
          <HappyAngleLeftIcon fill={defaultTheme.colors.goBrandBlue.base} />
        </S.SliderArrowLeft>
      )}
      {isRightCursorActive && (
        <S.SliderArrowRight
          onClick={eventMiddlewareForFE({
            onClick: () => {
              increment();
              sliderClicksGAHandler(`${rightCursor}`);
            },
          })}
        >
          <HappyAngleRightIcon fill={defaultTheme.colors.goBrandBlue.base} />
        </S.SliderArrowRight>
      )}
    </S.SuggestedMainWrapper>
  );
};

export default React.memo(TopDestinationsUI);

export interface ITopDestinationsData {
  trending_destinations: IDestinationsListInfo;
  popular_tags: {[key: string]: Array<string>};
  meta_config: {
    entities_data: {
      [key: string]: {
        lid: string;
        nh: string;
        asp: string;
        h_text: string;
        sub_text: string;
        img: Array<{
          fs_webp: string;
          format: string;
          url: string;
          align: string;
          base_url: string;
          srp_webp: string;
          th_webp: string;
        }>;
      };
    };
    template: string;
  };
  tags_data: {tags: {[key: string]: {n: string}}};
  popular_destinations: IDestinationsListInfo;
}

export interface IDestinationsListInfo {
  text: string;
  id_list: Array<string>;
}
